/*
  Сохранение настроек: ошибка, отметка об успехе и защита от двойного нажатия.

  Вынесено из `pages/SettingsPage.jsx` 27.10.2026 (предел размера страницы). Все формы
  настроек сохраняются через одну функцию `save`, поэтому правила держатся в одном месте.

  Отметка об успехе снимается перед КАЖДЫМ сохранением, а не только после отказа: без
  этого «Тарифы - сохранено» продолжало висеть над формой реквизитов, и человек считал
  сохранённым то, чего не сохранял.

  Повторное нажатие, пока идёт запрос, пропускается (аудит 26.10.2026, причина 4): две
  записи в журнале изменений и две отметки «сохранено» за одно действие.
*/

import { useCallback, useState } from 'react'

import useSingleFlight from './useSingleFlight.js'

export default function useSettingsSave() {
  const [error, setError] = useState(null)
  const [saved, setSaved] = useState(null)
  const { run, busy } = useSingleFlight()

  const save = useCallback(
    async (action, what) => {
      const result = await run(async () => {
        setError(null)
        setSaved(null)
        try {
          const done = await action()
          setSaved(what)
          return done
        } catch (failure) {
          setError(failure)
          return null
        }
      })
      return result ?? null
    },
    [run],
  )

  return { error, setError, saved, setSaved, save, saving: busy }
}
